import { useMemo } from 'react'

import { useAppConfirm } from '../contexts/AppConfirmProvider.tsx'
import { useError } from '../contexts/ErrorProvider.tsx'
import { useToast } from '../contexts/ToastContext.tsx'

/**
 * Utilidades generales para el manejo de componentes
 * @author isi-template
 */
export const useUtils = () => {
  const { toast } = useToast()
  const { requestConfirm } = useAppConfirm()
  const { showError } = useError()

  return useMemo(
    () => ({
      /** Mensajes flash */
      toast,
      /** Custom confirmación */
      requestConfirm,
      /** Excepcion de errores backend / api */
      showError,
    }),
    [toast, requestConfirm, showError],
  )
}
